<div class="pricelist-card">
    <div class="pricelist-card__container">
        <div class="pricelist-card__content">
            <div class="pricelist-card__header">
                <h3 class="pricelist-card__title">
                    {{ getTitle() }} #{{ pricelist.id }}
                </h3>
                <span class="pricelist-card__brand" *ngIf="pricelist.brands">
                    <span class="pricelist-card__brand-label">{{ TEXT.BRAND_LABEL }} </span>
                    <span class="pricelist-card__brand-value">{{ pricelist.brands }}</span>
                </span>
            </div>

            <div class="pricelist-card__info">
                <span class="pricelist-card__info-item">
                    {{ TEXT.MOV_LABEL }} {{ getMovDisplay() }}
                    <svg class="pricelist-card__info-icon" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                    </svg>
                </span>
                <ng-container *ngIf="getShippingDisplay()">
                    <span class="pricelist-card__separator">|</span>
                    <span>{{ getShippingDisplay() }}</span>
                </ng-container>
                <ng-container *ngIf="pricelist.prePaymentPercentage">
                    <span class="pricelist-card__separator">|</span>
                    <span>{{ TEXT.PRE_PAYMENT_LABEL }} {{ pricelist.prePaymentPercentage }}%</span>
                </ng-container>
            </div>

            <div
                class="pricelist-card__secondary-info"
                *ngIf="pricelist.fullPackageOnly || pricelist.highlights || getVolumeDiscountTeaser()"
            >
                <span *ngIf="pricelist.fullPackageOnly">{{ TEXT.FULL_BOXES_LABEL }}</span>
                <span class="pricelist-card__separator" *ngIf="pricelist.fullPackageOnly && pricelist.highlights">|</span>
                <span *ngIf="pricelist.highlights">{{ TEXT.HIGHLIGHTS_LABEL }} {{ pricelist.highlights }}</span>
                <span
                    class="pricelist-card__separator"
                    *ngIf="(pricelist.fullPackageOnly || pricelist.highlights) && getVolumeDiscountTeaser()"
                >|</span>
                <span *ngIf="getVolumeDiscountTeaser()">{{ getVolumeDiscountTeaser() }}</span>
            </div>
        </div>

        <div class="pricelist-card__actions">
            <button (click)="onViewClick()" class="pricelist-card__view-btn">
                {{ TEXT.VIEW_BUTTON }}
            </button>
            <vsf-export-download-menu
                [label]="TEXT.DOWNLOAD_LINK"
                buttonClass="pricelist-card__download-btn"
                [showDefaultIcon]="true"
                [showShareLink]="true"
                ariaLabel="Download pricelist"
                (download)="onDownloadClick($event)"
                (shareLink)="onShareClick($event)"
            ></vsf-export-download-menu>
        </div>
    </div>
</div>
